import { useModalForm } from '@/shared/hooks/useModalForm';
import { inspectionService } from '@/services/inspection.service';
import { AssignInspectionPayload } from '@/services/types/inspection.types';

export interface AssignFormData {
  destination?: string;
  providerId?: string;
  inspectorId?: string;
  notes?: string | undefined;
}

interface UseAssignInspectionModalProps {
  itemId: string;
  onClose: () => void;
  onSuccess: () => void;
}

type AssignResult = 'inspector' | 'provider';

export function useAssignInspectionModal({
  itemId,
  onClose,
  onSuccess,
}: UseAssignInspectionModalProps) {
  const { form, isSubmitting, handleFormSubmit } = useModalForm<AssignFormData, AssignResult>({
    onSubmit: async (values) => {
      if (values.destination === 'inspector' && values.inspectorId) {
        await inspectionService.assignInspectionItemDirectlyToInspector(itemId, {
          inspectorId: values.inspectorId,
          notes: values.notes || '',
        });
        return 'inspector';
      } else if (values.destination === 'provider' && values.providerId) {
        const payload: AssignInspectionPayload = {
          providerId: values.providerId,
          ...(values.notes && { notes: values.notes }),
        };
        await inspectionService.assignInspectionItemToProvider(itemId, payload);
        return 'provider';
      } else {
        throw new Error('Selecione um destinatário válido');
      }
    },
    onClose,
    onSuccess,
    successMessage: (result) =>
      result === 'inspector'
        ? 'Inspeção direcionada diretamente para o inspetor com sucesso!'
        : 'Inspeção direcionada para a prestadora com sucesso!',
    errorMessage: 'Erro ao direcionar inspeção',
  });

  return {
    form,
    isSubmitting,
    handleFormSubmit,
  };
}
